/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospectkpis_ProspectKpiStatusCountResponse = {
    /**
     * Count is the number of non-deleted prospects currently in that status.
     */
    count: number;
    /**
     * Status is one of the nine pipeline statuses, in pipeline order.
     */
    status: prospectkpis_ProspectKpiStatusCountResponse.status;
};
export namespace prospectkpis_ProspectKpiStatusCountResponse {
    /**
     * Status is one of the nine pipeline statuses, in pipeline order.
     */
    export enum status {
        NEW = 'NEW',
        IN_PROGRESS = 'IN_PROGRESS',
        TOUR_SCHEDULED = 'TOUR_SCHEDULED',
        TOUR_COMPLETED = 'TOUR_COMPLETED',
        FOLLOW_UP_OPEN = 'FOLLOW_UP_OPEN',
        CONTRACT_SENT = 'CONTRACT_SENT',
        CONTRACT_SIGNED = 'CONTRACT_SIGNED',
        ACTIVE = 'ACTIVE',
        ARCHIVED = 'ARCHIVED',
    }
}

